import { render, staticRenderFns } from "./CrgoCommodity.vue?vue&type=template&id=3d63a717&"
import script from "./CrgoCommodity.vue?vue&type=script&lang=js&"
export * from "./CrgoCommodity.vue?vue&type=script&lang=js&"
import style0 from "./CrgoCommodity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrgoCommodity.vue"
export default component.exports